var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78125 6.75C4.55747 6.75 4.34286 6.83889 4.18463 6.99713C4.02639 7.15536 3.9375 7.36997 3.9375 7.59375V14.9062C3.9375 15.13 4.02639 15.3446 4.18463 15.5029C4.34286 15.6611 4.55747 15.75 4.78125 15.75H13.2188C13.4425 15.75 13.6571 15.6611 13.8154 15.5029C13.9736 15.3446 14.0625 15.13 14.0625 14.9062V7.59375C14.0625 7.36997 13.9736 7.15536 13.8154 6.99713C13.6571 6.83889 13.4425 6.75 13.2188 6.75H11.8125C11.5018 6.75 11.25 6.49816 11.25 6.1875C11.25 5.87684 11.5018 5.625 11.8125 5.625H13.2188C13.7409 5.625 14.2417 5.83242 14.6109 6.20163C14.9801 6.57085 15.1875 7.07161 15.1875 7.59375V14.9062C15.1875 15.4284 14.9801 15.9292 14.6109 16.2984C14.2417 16.6676 13.7409 16.875 13.2188 16.875H4.78125C4.25911 16.875 3.75835 16.6676 3.38913 16.2984C3.01992 15.9292 2.8125 15.4284 2.8125 14.9062V7.59375C2.8125 7.07161 3.01992 6.57085 3.38913 6.20163C3.75835 5.83242 4.25911 5.625 4.78125 5.625H6.1875C6.49816 5.625 6.75 5.87684 6.75 6.1875C6.75 6.49816 6.49816 6.75 6.1875 6.75H4.78125Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78975 9.16475C6.00942 8.94508 6.36558 8.94508 6.58525 9.16475L9 11.5795L11.4148 9.16475C11.6344 8.94508 11.9906 8.94508 12.2102 9.16475C12.4299 9.38442 12.4299 9.74058 12.2102 9.96025L9.39775 12.7727C9.17808 12.9924 8.82192 12.9924 8.60225 12.7727L5.78975 9.96025C5.57008 9.74058 5.57008 9.38442 5.78975 9.16475Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.125C9.31066 1.125 9.5625 1.37684 9.5625 1.6875V11.8125C9.5625 12.1232 9.31066 12.375 9 12.375C8.68934 12.375 8.4375 12.1232 8.4375 11.8125V1.6875C8.4375 1.37684 8.68934 1.125 9 1.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.8010b9c5450cfae8d363b10297126dbb.svg";
export { ForwardRef as ReactComponent };